require('jquery.mmenu/dist/core/oncanvas/jquery.mmenu.oncanvas');
require('jquery.mmenu/dist/core/offcanvas/jquery.mmenu.offcanvas');
require('jquery.mmenu/dist/core/screenreader/jquery.mmenu.screenreader');
require('jquery.mmenu/dist/addons/autoheight/jquery.mmenu.autoheight');
require('jquery.mmenu/dist/addons/navbars/jquery.mmenu.navbars');
require('jquery.mmenu/dist/addons/navbars/_jquery.mmenu.navbar.close');
require('jquery.mmenu/dist/addons/setselected/jquery.mmenu.setselected');
require('jquery.mmenu/dist/addons/fixedelements/jquery.mmenu.fixedelements');

jQuery(document).ready(function ($) {

    var $menu = $("#header-nav").mmenu({
        extensions: [
            "theme-black",
            "fullscreen",
            "position-front",
            "multiline"
        ],
        "navbars": [
            {
                "position": "top",
                "content": [
                    "close"
                ]
            }
        ],
        "setSelected": {
            "current": true,
            "hover": true,
            "parent": true,
        }
    }, {
        // configuration
        clone: true,
        offCanvas: {
            pageNodetype: "main"
        },
        classNames: {
            selected: "selected" //Change this class to match the default li you want
        }
    });

    // Get the API
    var API = $menu.data("mmenu")

    API.bind('close:start', function() {
        $(".toggle").show();
        $("#menu-close").hide();
    });

    API.bind('open:start', function () {
        $(".toggle").hide();
        $("#menu-close").show();
    });

    $("#menu-close").click(function() {
        API.close();
    });

    // inject search field
    let container = document.createElement('div');
    container.className = 'container-fluid';
    let row = document.createElement('div');
    row.className = 'row';
    let col = document.createElement('div');
    col.className = 'col';


    row.appendChild(col);
    container.appendChild(row);

    $('#mm-header-nav > .mm-navbars_top > .mm-navbar').append(container);
    //$('.inter-header-bar-gray .inter-search').clone().appendTo('#mm-header-nav .mm-navbar .container-fluid .row .col');

    // search

    $("#search-nav").click(function() {

        $(".toggle").hide();
        $("#search-close").show();

        $(".inter-footer-search").animate({"bottom": "60px" }, 400, function() {

        });
    });

    $("#search-close").click(function() {

        $(".toggle").show();
        $("#search-close").hide();
        $(".tx-solr-q").val("");

        $(".inter-footer-search").animate({"bottom": "-60px" }, 400, function() {

        });
    });

    // contact

    $("#contact-nav").click(function() {

        try {
            KFIRST.open('activity', {activity: 'home'});
        } catch(e) {

        }

        $(".toggle").hide();
        $("#contact-close").show();

    });

    $("#contact-close").click(function() {

        try {
            KFIRST.close('widget');
        } catch(e) {

        }

        $(".toggle").show();
        $("#contact-close").hide();

    });

});
